module.exports = __webpack_public_path__ + "img/ieq-logo.5d2d6c89.png";